import { React, useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SongListCriteriaList from './SongListCriteriaList';

export default function SongListCatalogCriteria(props) {
    const [availableItems, setAvailableItems ] = 
        useState([]);
    const [includeItems, setIncludeItems ] = 
        useState([]);
    const [excludeItems, setExcludeItems ] =
        useState([]);

    return(
        <Row style={{ 'height': '44vh', 'max-height':'44vh'}}>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Available Catalogs</Card.Title>
                    <SongListCriteriaList items={availableItems}
                                        criteriaType='catalog'
                                        itemGroup='available' />
                    <Card.Footer className='text-muted'>Drag catalogs from here to use as selection criteria</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Included Catalogs</Card.Title>
                    <SongListCriteriaList items={includeItems}
                                        criteriaType='catalog'
                                        itemGroup='include' />
                    <Card.Footer className='text-muted'>Songs will be selected only from these catalogs</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Excluded Catalogs</Card.Title>
                    <SongListCriteriaList items={excludeItems}
                                        criteriaType='catalog'
                                        itemGroup='exclude' />
                    <Card.Footer className='text-muted'>Songs from these catalogs will not be in the song list</Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}